import { DeviceFaultEventKind } from '../../core/devices/events';
import * as enums from '../../enums';
import { DeviceBroadcastNetwork } from '../../enums/Devices';
import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
const serial = '20B8C9';
const model = 'CHP';
export const mockedDevice = {
    kind: 'device',
    id: 2649,
    createdAt: '1575471325',
    lastMeasuredAt: '1575480000',
    lastBatteryChange: '1575480000',
    brand: enums.Devices.Brand.weenat,
    serial,
    timezone: 'Europe/Paris',
    model,
    endUserName: [model, serial],
    availableMeasures: ['T', 'U'],
    organizationId: 137,
    originName: 'Mocked Organization Name',
    origin: enums.Devices.Origin.fromOwnOrganization,
    networkId: null,
    location: { type: 'Point', coordinates: [-1.65597, 47.27175] },
    messageQuality: [75, 67, 87, 53, 12, 34, 100],
    currentMessageQuality: 75,
    currentEvents: [
        { [DeviceFaultEventKind.lockedSpoon]: '1575480000' },
        { [DeviceFaultEventKind.lockedSpoon10Events]: '1575490000' }
    ],
    plotIds: [1, 2, 3],
    stationIds: [123],
    reverseGeocoding: 'Sautron, Loire-Atlantique',
    broadcastNetwork: DeviceBroadcastNetwork.LoRa,
    rotronicProbeChange: '1600000000',
    shared: true
};
const mockedDeviceEvent = {
    deviceId: 2649,
    faultType: DeviceFaultEventKind.lockedSpoon,
    start: '1575480000',
    end: '1575490000',
    createdAt: '1575471325'
};
const mockedDevicePlots = {
    deviceId: 12,
    plotIds: [12, 12]
};
const mockedDeviceBatteryHistory = ['1575480000', '1575480001', '1575480003'];
const mockedModelsList = [
    'CAPA-30-3',
    'CAPA-60-6',
    'CHP-15/30',
    'CHP-20',
    'CHP-30/60',
    'CHP-60/90',
    'LWS',
    'P+',
    'PAR',
    'PT',
    'PYRANO',
    'TH',
    'TSA',
    'T_GEL',
    'T_MINI',
    'VM',
    'W',
    'W+'
];
const mock = {
    delete: mockedRequester(undefined, 'devices.delete'),
    create: mockedRequester(mockedDevice, 'devices.create'),
    get: mockedRequester(mockedDevice, 'devices.get'),
    getMany: mockedRequester(mockedPaginatedResponse([mockedDevice]), 'devices.getMany'),
    getAll: mockedRequester([mockedDevice], 'devices.getAll'),
    getBatteryHistory: mockedRequester(mockedDeviceBatteryHistory, 'devices.getBatteryHistory'),
    linkPlots: mockedRequester(mockedDevicePlots, 'devices.linkPlots'),
    postBatteryChange: mockedRequester(undefined, 'devices.postBatteryChange'),
    deleteBatteryChange: mockedRequester(undefined, 'devices.deleteBatteryChange'),
    patchSharedStatus: mockedRequester(undefined, 'devices.patchSharedStatus'),
    getPage: mockedRequester(mockedPaginatedResponse([mockedDevice]), 'devices.getPage'),
    getEvents: mockedRequester([mockedDeviceEvent], 'devices.getEvents'),
    download: mockedRequester({}, 'devices.download'),
    getAvailableModels: mockedRequester(mockedModelsList, 'devices.getAvailableModels')
};
export default mock;
